import styled from "styled-components";

interface StepDivProp {
  bgImg?: string;
  left?: string;
  right?: string;
}
export const StepDiv = styled.div<StepDivProp>`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  flex: 1 0 0px;
  flex-shrink: 0;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 49px;
  justify-content: flex-start;
  overflow: hidden;
  padding: 80px 48px;
  position: relative;
  width: 50%;
  min-width: 360px;
  border-right: 1px solid rgb(31, 31, 31);
  border-top: 1px solid rgb(31, 31, 31);
  svg {
    width: 36px;
    height: 36px;
  }
  .title {
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: none;
    > h3 {
      font-size: 24px;
      margin: 0;
    }
  }
  .description {
    outline: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-shrink: 0;
    transform: none;
    > p {
      font-size: 18px;
      line-height: 24px;
      margin: 0;
      color: rgb(161, 161, 161);
    }
  }
  @media (max-width: 900px) {
    width: 50%;
    text-align: center;

    .title {
      > h3 {
        font-size: 24px;
        margin: 0;
      }
    }
  }
  @media (max-width: 719px) {
    align-items: center;
  }

  @media (max-width: 450px) {
    width: 100%;
    min-width: 250px;
    flex: 1;
    padding: 36px 16px;
    text-align: left;
    align-items: start;
    .description {
      > p {
        font-size: 16px;
      }
    }
  }
`;

export const StepMainDiv = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 0%;
  flex-wrap: wrap;

  text-align: left;

  min-width: 360px;
  max-width: 1300px;
  border-left: 1px solid rgb(31, 31, 31);
  border-bottom: 1px solid rgb(31, 31, 31);

  align-items: stretch;
  .container {
    align-items: flex-start;
    display: flex;
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 18px;
    height: min-content;
    justify-content: center;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 100%;
  }

  h3 {
    font-size: 4.5rem;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.03em;
  }

  @media (max-width: 900px) {
    margin: 0;
    width: 100%;
    text-align: center;
    > h3 {
      font-size: 2em;
    }
    .container {
      align-items: center;
    }
  }
  @media (max-width: 450px) {
    flex-flow: column;
    .container {
      align-items: start;
    }
  }
`;
